import { Component, OnInit, Input } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-document-attributes',
  templateUrl: './document-attributes.component.html',
  styleUrls: ['./document-attributes.component.css']
})
export class DocumentAttributesComponent implements OnInit {

  @Input() attributes:FormArray;
  constructor() { }

  ngOnInit() {
  }

}
